import { connect } from 'react-redux';

import SearchComponent from '../../components/search';

import {
	fetchVendors,
	setAwardType,
	setCategory,
	setLocation,
} from '../../actions';

/** @internal */
export function mapStateToProps(state) {
	return {
		category: state.bow.category,
		awardType: state.bow.awardType,
		location: state.bow.location,
		anonymousId: state.settings?.anonymousId,
		userId: state.membership?.member?.id,
	};
}

/** @internal */
export const mapDispatchToProps = {
	setCategory,
	setLocation,
	setAwardType,
	fetchVendors,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchComponent);
